import { render, staticRenderFns } from "./listaAdminPedidos.vue?vue&type=template&id=5000a6ea&scoped=true&"
import script from "./listaAdminPedidos.vue?vue&type=script&lang=js&"
export * from "./listaAdminPedidos.vue?vue&type=script&lang=js&"
import style0 from "./listaAdminPedidos.vue?vue&type=style&index=0&id=5000a6ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5000a6ea",
  null
  
)

export default component.exports